import { memo } from "react";
import { cn } from "../../utils/tailwind";

export const Title = memo(({ children, className }) => (
    <h1 className={cn("text-3xl font-bold text-neutralStrongBlack mb-2", className)}>
        {children}
    </h1>
));

Title.displayName = "Title";

export const Subtitle = memo(({ children, className }) => (
    <h2 className={cn("text-neutralDarkBlack align-center text-md sm:text-lg font-semibold sm:leading-[24px]", className)}>
        {children}
    </h2>
));


Subtitle.displayName = "Subtitle";